import store from '@/store/index'
import { getShopList, getErpShopList } from '@/server/shopList'
export default {
    state: {
        shopList: []
    },
    mutations: {
        setShopList(state, data) {
            state.shopList = data
        }
    },
    actions: {
        async getShopList() {
            // let shopList = [{ shopName: window.$t('system::common::select_all_shop'), shopId: undefined }]
            let shopList = []
            if (store.state.user.sourceType === 1) {
                const { data } = await getShopList({ pageSize: 10000, pageNum: 1 })
                if (data.code === 0) {
                    shopList = [...shopList, ...((data.data && data.data.items) || [])]
                }
            } else if (store.state.user.sourceType === 2) {
                const { data } = await getErpShopList(store.state.user.merchantId)
                if (data.code === 0) {
                    shopList = [...shopList, ...(data.data || [])]
                }
            }
            store.commit('setShopList', shopList.map(el => ({ label: el.shopName, value: el.shopId })))
        },
    }
}